function parse(paramA, paramB){

    let msg = paramA;
    if (paramB !== undefined)
        msg += "   " + paramB;
    msg += "\n";
    return msg;
}

export function overrideConsole() {
    console.warn("overriding console");
    console.error = (paramA, paramB) => {
      const el = document.getElementById('debug-div');
      if (el != null){
        el.innerHTML +=  "<div class='color-red'>" + parse(paramA, paramB) + "</div>";
      }
    }

    console.warn = (paramA, paramB) => {
      const el = document.getElementById('debug-div');
      if (el != null){
        el.innerHTML +=  "<div class='color-orange'>" + parse(paramA, paramB) + "</div>";
      }
    }

    console.log = (paramA, paramB) => {
      const el = document.getElementById('debug-div');
      if (el != null){
        el.innerHTML +=  "<div>" + parse(paramA, paramB) + "</div>";
      }
    }

    window.onerror = (msg, url, line) =>{
      const el = document.getElementById('debug-div');
      if (el != null){

        el.innerHTML +=  "<div class='color-red'>" +line + ">> " + msg + " " + url  + "</div>";
      }

    }

}